export default __webpack_public_path__ + "static/media/0x05089c9ebffa4f0aca269e32056b1b36b37ed71b.5d571e56.jpeg";